export const CANVAS_ZOOM_MIN = 0.1
export const CANVAS_ZOOM_MAX = 8

/** Padding inside the scroll viewport when fitting spread/page (matches zoom-to-selection padding). */
export const FIT_TO_SPREAD_VIEW_PADDING_PX = 48
